import Vue from "vue";
import {
  DynamicService
} from "@/common/api.service";

import {
  ARTICLE_PUBLISH,
  ARTICLE_EDIT,
  ARTICLE_DELETE,
  ARTICLE_RESET_STATE,
  FETCH_ARTICLE,
  FETCH_ARTICLES,
  FETCH_ARTICLES_COUNT,
  FETCH_BLOG,
  FETCH_BLOG_COUNT,
  FETCH_VIDEOS,
  FETCH_VIDEOS_COUNT,
  SEARCH_ARTICLES
} from "./actions.type";

import {
  RESET_STATE,
  SET_ARTICLE,
  APPEND_ARTICLES,
  SET_ARTICLES_COUNT,
  FETCH_END_ARTICLES,
  FETCH_START_ARTICLES,
  APPEND_BLOG,
  SET_BLOG_COUNT,
  FETCH_END_BLOG,
  FETCH_START_BLOG,
  APPEND_VIDEOS,
  SET_VIDEOS_COUNT,
  FETCH_END_VIDEOS,
  FETCH_START_VIDEOS
} from "./mutations.type";

const initialState = {
  article: {
    slug: "",
    published: {
      year: "",
      in: ""
    },
    title: "",
    subtitle: "",
    image: {
      data: "",
      showInPost: false,
      description: ""
    },
    previewImage: "",
    isLightTheme: false,
    variantSlug: "",
    bookSlug: "",
    authorSlug: "",
    productSlug: "",
    linkedProduct: {
      slug: "",
      name: "",
      link: "",
      image: ""
    },
    secondLinkedProduct: {
      slug: "",
      name: "",
      link: "",
      image: ""
    },
    variants: [],
    content: [],
    author: {
      slug: "",
      name: {
        title: "",
        name: "",
        surname: ""
      },
    },
  },
  articles: [],
  videos: [],
  blog: [],
  isLoadingArticles: false,
  articlesCount: 0,
  isLoadingBlog: false,
  blogCount: 0,
  isLoadingVideos: false,
  videosCount: 0
};

const defaultParamsArticle = {
  include: [
    "author",
    "content",
    "linkedProduct",
    "secondLinkedProduct",
    "linkedBook",
    "variants"
  ]
}
const defaultParamsArticles = {
  order: "createdAt DESC",
  fields: {
    urls: false,
    isLightTheme: false,
    image: false,
  }
}

const resource = "Articles"

export const state = { ...initialState };

export const actions = {
  async [FETCH_ARTICLE](context, { slug, prevArticle, params}) {
    // avoid extronuous network call if article exists
    if (prevArticle !== undefined) {
      return context.commit(SET_ARTICLE, prevArticle);
    }

    // console.log(context)
    if (params == undefined) {
      params = defaultParamsArticle;
    }

    const { data } = await DynamicService.get(resource, slug, params);
    if (!data.linkedProduct) {
      data.linkedProduct = {
        slug: "",
        name: "",
        link: "",
        image: ""
      }
    }
    if (!data.secondLinkedProduct) {
      data.secondLinkedProduct = {
        slug: "",
        name: "",
        link: "",
        image: ""
      }
    }
    if (!data.linkedBook) {
      data.linkedBook = {
        slug: "",
        title: "",
        previewImage: ""
      }
    }
    if (!data.category) {
      data.category = ""
    }
    if (!data.published) {
      console.log("data.published")
      data.published = {
        in: "",
        year: ""
      }
    }
    if (!data.variants) {
      data.variants = []
    }
    context.commit(SET_ARTICLE, data);
    return data;
  },
  async [FETCH_ARTICLES_COUNT](context) {
    const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"article"}) + "&");
    context.commit(SET_ARTICLES_COUNT, data.count);
    return data.count
  },
  async [FETCH_ARTICLES]({ commit, state }, params) {
    if (!state.isLoadingArticles) {
      commit(FETCH_START_ARTICLES);
      console.log("start fetch")

      // console.log(context)
      if (params == undefined) {
        params = JSON.parse(JSON.stringify(defaultParamsArticles));
        params.where = {
          "category": "article"
        }
      }

      var articlesCount = 0

      if (state.articlesCount == 0) {
        const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"article"}) + "&");
        commit(SET_ARTICLES_COUNT, data.count);
        articlesCount = data.count
      } else {
        articlesCount = state.articlesCount
      }

      var batch = 9

      if (state.articles.length < articlesCount) {
        params.limit = batch
        params.skip = state.articles.length

        DynamicService.query(resource, params)
        .then(({ data }) => {
          commit(APPEND_ARTICLES, data);
          commit(FETCH_END_ARTICLES);
        })
        .catch(error => {
          commit(FETCH_END_ARTICLES);
          throw new Error(error);
        });
      } else {
        commit(FETCH_END_ARTICLES);
      }
    }

    return
  },
  async [SEARCH_ARTICLES](context, params) {
    return new Promise(async (resolve, reject) => {
      if (params == undefined) {
        params = defaultParamsBooks;
      }

      params.limit = 18

      // do for loop
      DynamicService.query(resource, params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
    })
  },
  [ARTICLE_PUBLISH]({ state }) {
    var postCarVariants = []
    for (var variant of state.article.variants) {
      postCarVariants.push({
        variantSlug: variant.slug,
        postSlug: state.article.slug
      })
    }
    console.log(postCarVariants)
    DynamicService.create("PostCarVariants", postCarVariants);
    DynamicService.create(resource, state.article);
    return DynamicService.create(resource + "/" + state.article.slug + "/content", state.article.content);
  },
  [ARTICLE_DELETE](context, slug) {
    DynamicService.destroy(resource, slug + "/content");
    DynamicService.destroy(resource, slug + "/variants");
    return DynamicService.destroy(resource, slug);
  },
  [ARTICLE_EDIT]({ state }) {
    console.log("in ARTICLE_EDIT")
    console.log(state.article)

    // Variant-Link
    DynamicService.update(resource, state.article.slug, state.article);
    DynamicService.destroy(resource, state.article.slug + "/variants");
    var postCarVariants = []
    for (var variant of state.article.variants) {
      postCarVariants.push({
        variantSlug: variant.slug,
        postSlug: state.article.slug
      })
    }

    if (postCarVariants.length > 0) {
      DynamicService.create("PostCarVariants", postCarVariants);
    }

    // Content
    DynamicService.destroy(resource, state.article.slug + "/content");
    return DynamicService.create(resource + "/" + state.article.slug + "/content", state.article.content);
  },
  [ARTICLE_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  },
  async [FETCH_BLOG]({ commit, state }, params) {
    if (!state.isLoadingBlog) {
      commit(FETCH_START_BLOG);
      console.log("start fetch")

      // console.log(context)
      if (params == undefined) {
        params = JSON.parse(JSON.stringify(defaultParamsArticles));
        params.where = {
          "category": "blog"
        }
      }

      var blogCount = 0

      if (state.blogCount == 0) {
        const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"blog"}) + "&");
        commit(SET_BLOG_COUNT, data.count);
        blogCount = data.count
      } else {
        blogCount = state.blogCount
      }

      var batch = 9

      if (state.blog.length < blogCount) {
        params.limit = batch
        params.skip = state.blog.length

        DynamicService.query(resource, params)
        .then(({ data }) => {
          commit(APPEND_BLOG, data);
          commit(FETCH_END_BLOG);
        })
        .catch(error => {
          commit(FETCH_END_BLOG);
          throw new Error(error);
        });
      } else {
        commit(FETCH_END_BLOG);
      }
    }

    return
  },
  async [FETCH_BLOG_COUNT](context) {
    const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"blog"}) + "&");
    context.commit(SET_BLOG_COUNT, data.count);
    return data.count
  },
  async [FETCH_VIDEOS]({ commit, state }, params) {
    if (!state.isLoadingVideos) {
      commit(FETCH_START_VIDEOS);
      console.log("start fetch")

      // console.log(context)
      if (params == undefined) {
        params = JSON.parse(JSON.stringify(defaultParamsArticles));
        params.where = {
          "category": "video"
        }
        console.log("params")
        console.log(params)
      }

      var videosCount = 0

      if (state.videosCount == 0) {
        const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"video"}) + "&");
        commit(SET_VIDEOS_COUNT, data.count);
        videosCount = data.count
      } else {
        videosCount = state.videosCount
      }

      var batch = 9

      if (state.videos.length < videosCount) {
        console.log("state.articles.length")
        console.log(state.videos.length)
        console.log("videosCount")
        console.log(videosCount)
        params.limit = batch
        params.skip = state.videos.length

        DynamicService.query(resource, params)
        .then(({ data }) => {
          commit(APPEND_VIDEOS, data);
          commit(FETCH_END_VIDEOS);
        })
        .catch(error => {
          commit(FETCH_END_VIDEOS);
          throw new Error(error);
        });
      } else {
        commit(FETCH_END_VIDEOS);
      }
    }

    return
  },
  async [FETCH_VIDEOS_COUNT](context) {
    // console.log(context)
    const { data } = await DynamicService.get(resource, "count?where=" + JSON.stringify({"category":"video"}) + "&");
    context.commit(SET_VIDEOS_COUNT, data.count);
    return data.count
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_ARTICLE](state, article) {
    state.article = article;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
  [FETCH_START_ARTICLES](state) {
    console.log("is loading true")
    state.isLoadingArticles = true;
  },
  [SET_ARTICLES_COUNT](state, count) {
    state.articlesCount = count;
  },
  [FETCH_END_ARTICLES](state) {
    console.log("is loading false")
    state.isLoadingArticles = false;
  },
  [APPEND_ARTICLES](state, articles) {
    state.articles.push(...articles);

    state.articles = state.articles.filter((article, index, self) =>
      index === self.findIndex((a) => (
        a.slug === article.slug
      ))
    )
    // state.articlesCount += articles.length;
  },
  [FETCH_START_BLOG](state) {
    console.log("is loading true")
    state.isLoadingBlog = true;
  },
  [SET_BLOG_COUNT](state, count) {
    state.blogCount = count;
  },
  [FETCH_END_BLOG](state) {
    console.log("is loading false")
    state.isLoadingBlog = false;
  },
  [APPEND_BLOG](state, blog) {
    state.blog.push(...blog);
    // state.blogCount += blog.length;
  },
  [FETCH_START_VIDEOS](state) {
    console.log("is loading true")
    state.isLoadingVideos = true;
  },
  [SET_VIDEOS_COUNT](state, count) {
    state.videosCount = count;
  },
  [FETCH_END_VIDEOS](state) {
    console.log("is loading false")
    state.isLoadingVideos = false;
  },
  [APPEND_VIDEOS](state, videos) {
    state.videos.push(...videos);
    // state.videosCount += videos.length;
  }
};

const getters = {
  defaultParamsArticles() {
    return JSON.parse(JSON.stringify(defaultParamsArticles))
  },
  article(state) {
    return state.article;
  },
  articlesCount(state) {
    return state.articlesCount;
  },
  articles(state) {
    return state.articles;
  },
  isLoadingArticles(state) {
    return state.isLoadingArticles;
  },
  blogCount(state) {
    return state.blogCount;
  },
  blog(state) {
    return state.blog;
  },
  isLoadingBlog(state) {
    return state.isLoadingBlog;
  },
  videosCount(state) {
    return state.videosCount;
  },
  videos(state) {
    return state.videos;
  },
  isLoadingVideos(state) {
    return state.isLoadingVideos;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
